export const RELATIONSHIPS = [
  {
    label: 'Mother',
    value: 'mother',
  },
  {
    label: 'Father',
    value: 'father',
  },
  {
    label: 'Grandparent',
    value: 'grandparent',
  },
  {
    label: 'Aunt/Uncle',
    value: 'aunt/uncle',
  },
  {
    label: 'Social Worker',
    value: 'social worker',
  },
  {
    label: 'Carer',
    value: 'carer',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
